module.exports = __webpack_public_path__ + "img/intro2.31ec4890.png";